function datetimeColorGradient(datetime) {
    // Choose color based on how recent datetime is
    const now = new Date()
    const lastStateChange = new Date(datetime)
    let stateChangeDays = (now - lastStateChange) / (1000 * 60 * 60 * 24)
    if (stateChangeDays < 0) stateChangeDays = 0;
    if (stateChangeDays > 100) stateChangeDays = 100;

    const red = 255;
    // const red = Math.floor((stateChangeDays) * 2.55);
    const blue = Math.floor((100 - stateChangeDays) * 2.55);
    const green = Math.floor((100 - stateChangeDays) * 2.55);
    return `rgb(${red},${green},${blue})`
}

export {datetimeColorGradient};